/**
 * Generates a unique ID using timestamp + random string.

 *
 * @returns {string} e.g. "1710000000000-a3f9z2k"
 */
export const generateId = () => `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;

export const getStepStatus = (item) => item?.test_step_status ?? item?.Status;
